/**
 * The panel of each type the user last pressed into, so an action aimed at
 * "the chart" (the chat's Open on chart) lands on the one they were using
 * when the layout has several. Plain module state: no subscriptions, read on
 * demand. Installed once by the companion host.
 */
const lastByType = new Map<string, string>()
/** When each panel was last pressed, in presses, across every type. */
const pressedAt = new Map<string, number>()
let presses = 0
let installed = false

function onPointerDown(e: Event): void {
  const el = (e.target as Element | null)?.closest?.('[data-panel-id]')
  if (!el) return
  const id = el.getAttribute('data-panel-id')
  const type = el.getAttribute('data-panel-type')
  if (id && type) {
    lastByType.set(type, id)
    pressedAt.set(id, ++presses)
  }
}

export function installLastPanelTracker(): () => void {
  if (installed || typeof document === 'undefined') return () => {}
  installed = true
  document.addEventListener('pointerdown', onPointerDown, true)
  return () => {
    document.removeEventListener('pointerdown', onPointerDown, true)
    installed = false
  }
}

/** The last-used panel of `type` among `candidates`, else the first candidate. */
export function pickPanel(type: string, candidates: string[]): string | null {
  const last = lastByType.get(type)
  if (last && candidates.includes(last)) return last
  return candidates[0] ?? null
}

/**
 * The candidate the user pressed most recently, whatever its type, or null when
 * none was pressed: a shared capability (filters, columns) spans panel types.
 */
export function lastPressedOf(candidates: string[]): string | null {
  let best: string | null = null
  for (const id of candidates)
    if ((pressedAt.get(id) ?? 0) > (best ? (pressedAt.get(best) ?? 0) : 0)) best = id
  return best
}

/** Test seam. */
export function __resetLastPanelTracker(): void {
  lastByType.clear()
  pressedAt.clear()
  presses = 0
}
